import type { DriverMarker, LiveMapDriver, LiveMapDriverStatus } from './live-map.types'

/** Palette des marqueurs : vert = libre, orange = en course (cf. SCRUM-78). */
export const MARKER_COLORS: Record<LiveMapDriverStatus, string> = {
  FREE: '#22C55E',
  ON_RIDE: '#F59E0B',
}

export function markerColor(status: LiveMapDriverStatus): string {
  return MARKER_COLORS[status] ?? MARKER_COLORS.FREE
}

/**
 * Transforme la réponse de `GET /admin/live-map` en view-models de marqueurs.
 * Fonction pure et déterministe : à entrée identique, sortie structurellement
 * identique → permet la mémoïsation (`useMemo`) côté page pour éviter de
 * recréer les marqueurs (et donc de réinitialiser la carte) à chaque polling.
 */
export function toDriverMarkers(drivers: LiveMapDriver[]): DriverMarker[] {
  return drivers.map((d) => ({
    id: d.driverUserId,
    position: { lat: d.lat, lng: d.lng },
    color: markerColor(d.status),
    status: d.status,
    activeRide: d.activeRide,
  }))
}
